import { styled } from '@mui/material/styles';
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Typography,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  centerContent: 'centerContent',
  uploadFile: 'uploadFile',
  chooseFileBtn: 'chooseFileBtn',
  titleText: 'titleText',
  paragraphTextBox: 'paragraphTextBox',
  CloseAction: 'CloseAction',
  uploadButton: 'uploadButton',
  uploadIcon: 'uploadIcon',
  uploadButtonSelection: 'uploadButtonSelection',
  applyAndReset: 'applyAndReset',
  buttonsTypo: 'buttonsTypo',
};

export const MenuItemUpload = styled(MenuItem)(({ theme }) => ({
  ':hover': {
    background: theme.palette.primary.lighter,
  },
}));

export const FilenameTypography = styled(Typography)(() => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  width: '7vw',
  textOverflow: 'ellipsis',
}));

export const FromEmailTypography = styled(Typography)(() => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  width: '12vw',
  textOverflow: 'ellipsis',
}));

export const IconBox = styled(Box)(() => ({
  [up('xs')]: {
    width: '16px',
    height: '16px',
  },
  [up('sm')]: {
    width: '18px',
    height: '18px',
  },
  [up('md')]: {
    width: '20px',
    height: '20px',
  },
  [up('lg')]: {
    width: '22px',
    height: '22px',
  },
  [up('xl')]: {
    width: '24px',
    height: '24px',
  },
  [up('xxl')]: {
    width: '26px',
    height: '26px',
  },
}));

export const ListItemTypo = styled(Typography)(({ theme }) => ({
  paddingLeft: '10px',
  textAlign: 'center',
  fontWeight: '400',
  color: theme.palette.shoeWax.darker,
}));

export const StyledMenuPropsForUploadButton = {
  PaperProps: {
    sx: {
      width: {
        xs: '110px',
        sm: '125px',
        md: '130px',
        lg: '140px',
        xl: '160px',
        xxl: '175px',
      },
    },
  },
};

export const SaveButton = styled(Button)(() => ({
  marginTop: 0,
  [up('xs')]: {
    width: '80px',
    height: '30px',
    margin: '3px',
  },
  [up('sm')]: {
    width: '99px',
    height: '40px',
    margin: '4px',
  },
  [up('md')]: {
    width: '110px',
    height: '40px',
    margin: '6px',
  },
  [up('lg')]: {
    width: '110px',
    height: '44px',
    margin: '7px',
  },
  [up('xl')]: {
    width: '150px',
    height: '54px',
    margin: '10px',
  },
  [up('xxl')]: {
    width: '150px',
    height: '54px',
    margin: '10px',
  },
}));

export const OrButton = styled(Button)(() => ({
  padding: '0',
  margin: '0',
  minWidth: '0',
}));

export const ColoredGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: 'f0f8ff',
  padding: '10px 0px',
  borderRadius: '5px',
  color: theme.palette.darkPurple.main,
}));

export const AndTypography = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.lavenderMist.main,
  padding: '4px 20px',
  borderRadius: '10px',
}));

export const CustomDivider = styled(Divider)(({ theme }) => ({
  '&::before, &::after': {
    borderTop: `1px dashed ${theme.palette.primary.main}`,
  },
  width: '60%',
  margin: 'auto',
  padding: '20px 0px',
}));

export const AndButton = styled(Button)(() => ({
  width: 'max-content',
  minWidth: '0',
  padding: '10px 0px',
}));

export const CustomHeader = styled(DataGrid)(() => ({
  '& .MuiDataGrid-columnHeaderRow': {
    backgroundColor: 'red', // Your desired background color
    color: 'white', // Optional: to change the text color
  },
}));

export const DialogActionsWithMargin = styled(DialogActions)(() => ({
  marginTop: 'auto',
}));

export const CloseIonButton = styled(IconButton)(() => ({
  position: 'absolute',
  right: 8,
  top: 8,
  color: (theme) => theme.palette.grey[500],
}));

export const OrCloseIonButton = styled(IconButton)(() => ({
  cursor: 'pointer',
  backgroundColor: '#EEEDF2',
  borderRadius: '0',
}));

export const FetchedMailList = styled(Box)(() => ({
  [up('xs')]: {
    height: '280px',
  },
  [up('sm')]: {
    height: '190px',
  },
  [up('md')]: {
    height: '280px',
  },
  [up('lg')]: {
    height: '370px',
  },
  [up('xl')]: {
    height: '450px',
  },
  [up('xxl')]: {
    height: '540px',
  },
}));

export const StyledDataGrid = styled(DataGrid)(() => ({
  '& ::-webkit-scrollbar': {
    width: '0.4em',
  },
  '& ::-webkit-scrollbar-track': {
    background: '#D9D9D9',
    borderRadius: '5px',
  },
  '& ::-webkit-scrollbar-thumb': {
    borderRadius: '5px',
    backgroundColor: '#868686',
  },
}));

export const FetchedMailsDialogContent = styled(DialogContent)(({ theme }) => ({
  // borderRadius: '5px',
  // border: `1px solid ${theme.palette.secondaryBlack.lighter}`,
  overflow: 'auto',
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    background: '#D9D9D9',
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#868686',
    borderRadius: '5px',
  },
  '& .custom_header': {
    backgroundColor: theme.palette.japanBlush.medium,
    color: theme.palette.darkPurple.main,
    overflow: 'hidden',
  },
  '& .MuiDataGrid-columnHeaderCheckbox': {
    backgroundColor: theme.palette.japanBlush.medium,
  },
}));

export const ErrorInfoDialogContent = styled(DialogContent)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const FetchedEmailGrid = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const StyledMenuPropsForChooseButton = {
  PaperProps: {
    sx: {
      width: {
        xs: '110px',
        sm: '125px',
        md: '130px',
        lg: '140px',
        xl: '160px',
        xxl: '175px',
      },
    },
  },
};

export const CancelButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.paperWhite.main,
  color: theme.palette.lunarBase.main,
  marginTop: 0,
  [up('xs')]: {
    width: '80px',
    height: '30px',
    margin: '3px',
  },
  [up('sm')]: {
    width: '99px',
    height: '40px',
    margin: '4px',
  },
  [up('md')]: {
    width: '110px',
    height: '40px',
    margin: '6px',
  },
  [up('lg')]: {
    width: '110px',
    height: '44px',
    margin: '7px',
  },
  [up('xl')]: {
    width: '150px',
    height: '54px',
    margin: '10px',
  },
  [up('xxl')]: {
    width: '150px',
    height: '54px',
    margin: '10px',
  },
}));

export const DialogContentScrollbar = styled(DialogContent)(({ theme }) => ({
  padding: '10px 5px',
  margin: '0px 10px',
  '.MuiDialog-paper': {
    [up('sm')]: {
      height: '320px',
    },
    [theme.breakpoints.up('md')]: {
      height: '420px',
    },
    [theme.breakpoints.up('lg')]: {
      height: '520px',
    },
    [theme.breakpoints.up('xl')]: {
      height: '620px',
    },
    [theme.breakpoints.up('xxl')]: {
      height: '720px',
    },
  },
  borderRadius: '5px',
  overflow: 'auto',
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    background: theme.palette.lunarBase.main,
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.lunarBase.main,
    borderRadius: '5px',
  },
}));

export const StyledFilterPopup = styled(Dialog)(() => ({
  '.MuiDialog-paper': {
    [up('sm')]: {
      width: '600px',
      height: '350px',
      maxWidth: '600px',
    },
    [up('md')]: {
      width: '600px',
      height: '450px',
      maxWidth: '800px',
    },
    [up('lg')]: {
      width: '700px',
      height: '550px',
      maxWidth: '900px',
    },
    [up('xl')]: {
      width: '800px',
      height: '650px',
      maxWidth: '800px',
    },
    [up('xxl')]: {
      width: '1000px',
      height: '750px',
      maxWidth: '1000px',
    },
  },
}));

export const FilterPopUpHeader = styled(DialogTitle)(({ theme }) => ({
  color: theme.palette.darkPurple.main,
  backgroundColor: theme.palette.japanBlush.main,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));
export const FilterPopupCloseIcon = styled(Avatar)(() => ({
  width: '20px',
  cursor: 'pointer',
  height: '100%',
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    border: `1px dashed ${theme.palette.darkPurple.main}`,
    marginTop: theme.spacing(1),
    [up('xs')]: {
      // marginTop: '58px',
      height: '60vh',
    },
    [up('sm')]: {
      // marginTop: '62px',
      height: '75vh',
    },
    [up('md')]: {
      // marginTop: '66px',
      height: '55vh',
    },
    [up('lg')]: {
      // marginTop: '70px',
      height: '55vh',
    },
    [up('xl')]: {
      // marginTop: '76px',
      height: '53vh',
    },
    [up('xxl')]: {
      // marginTop: '80px',
      height: '65vh',
    },
  },

  [`& .${classes.CloseAction}`]: {
    cursor: 'pointer',
    width: '20%',
    height: '100%',
  },

  [`& .${classes.centerContent}`]: {
    textAlign: 'center',
  },

  [`& .${classes.emailSubjectTypography}`]: {
    background: 'red',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  [`& .${classes.uploadFile}`]: {
    marginBottom: theme.spacing(2),
    [up('xs')]: {
      width: '60px',
      height: '45px',
    },
    [up('sm')]: {
      width: '90px',
      height: '65px',
    },
    [up('md')]: {
      width: '90px',
      height: '65px',
    },
    [up('lg')]: {
      width: '115px',
      height: '80px',
    },
    [up('xl')]: {
      width: '130px',
      height: '85px',
    },
    [up('xxl')]: {
      width: '146px',
      height: '110px',
    },
  },
  [`& .${classes.chooseFileBtn}`]: {
    ':hover': {
      background: theme.palette.primary.main,
      color: 'white',
    },
    [up('xs')]: {
      width: '75px',
      height: '20px',
    },
    [up('sm')]: {
      width: '90px',
      height: '30px',
    },
    [up('md')]: {
      width: '93px',
      height: '33px',
    },
    [up('lg')]: {
      width: '130px',
      height: '40px',
    },
    [up('xl')]: {
      width: '130px',
      height: '40px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '50px',
    },
  },
  [`& .${classes.paragraphTextBox}`]: {
    width: '63%',
    [up('xs')]: {
      margin: '10px auto 25px',
    },
    [up('sm')]: {
      margin: '8px auto 26px',
    },
    [up('md')]: {
      margin: '10px auto 28px',
    },
    [up('lg')]: {
      margin: '10px auto 32px',
    },
    [up('xl')]: {
      margin: '12px auto 37px',
    },
    [up('xxl')]: {
      margin: '16px auto 43px',
    },
  },

  [`& .${classes.uploadButton}`]: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    background: theme.palette.primary.main,
    color: theme.palette.secondaryWhite.main,
    ':hover': {
      background: theme.palette.primary.main,
      color: theme.palette.secondaryWhite.main,
    },
    minWidth: '0px',
    [up('xs')]: {
      width: '32px',
      height: '32px',
    },
    [up('md')]: {
      width: '90px',
      height: '32px',
    },
  },
  [`& .${classes.applyAndReset}`]: {
    minWidth: '0px',
    [up('xs')]: {
      width: '32px',
      height: '32px',
    },
    [up('md')]: {
      width: '120px',
      height: '32px',
    },
  },
  [`& .${classes.uploadIcon}`]: {
    [up('xs')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '18px',
      height: '18px',
    },
  },
  [`& .${classes.buttonsTypo}`]: {
    padding: '0 8px',
    [up('xs')]: {
      display: 'none',
    },
    [up('md')]: {
      display: 'block',
    },
  },
  [`& .${classes.uploadButtonSelection}`]: {
    background: theme.palette.primary.main,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: `1px solid ${theme.palette.secondaryWhite.lighter}`,
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiSelect-icon': {
      color: `${theme.palette.secondaryWhite.main} !important`,
    },
    width: '32px',
    height: '32px',
  },
}));
